export var CustomGradeCode;
(function (CustomGradeCode) {
    CustomGradeCode["Color"] = "color-1";
    CustomGradeCode["ColorViBox2"] = "color-2";
    CustomGradeCode["ColorViBox3"] = "color-3";
    CustomGradeCode["DeadZone"] = "deadzones";
})(CustomGradeCode || (CustomGradeCode = {}));
